import {defineStore} from 'pinia';
import {ModuleActivity} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';

import activityAPI from '@/apis/di/activityAPI';
const activityStore = new BaseDictionaryStore(activityAPI);
export const useActivityStore = defineStore(ModuleActivity, {
  state: () => ({
    ...activityStore.state,
    _config: {
      key: 'activity_id',
      code: 'activity_code',
      name: 'activity_name',
      table: 'di_activity',
      moduleName: 'Hoạt động tài chính',
      quickFollow: 'active',
      defaultSort: 'activity_code',
    },
    moduleName: 'activity',
  }),
  actions: {
    ...activityStore.action,
  },
  getters: {
    ...activityStore.getters,
  },
});
